import styled from 'styled-components';
import { Grid } from '@mui/material';
import { colors } from 'spw-theme';
import { GridProps } from '@mui/material/Grid';
import React from 'react';
import CardAtom from 'spw-components/atomic/atoms/card';
import { BulkEditButton } from 'spw-projects/components/styles';

export const Card = CardAtom;

export const CardTitle = styled.div`
  && {
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    display: flex;
    align-items: center;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    margin-bottom: 16px;
    color: #4a4a4a;
  }
`;

export const SpaceTypeGroupHeaderContainer = styled((props: GridProps) => (
  <Grid container {...props} />
))`
  && {
    align-items: center;
    height: 100%;
  }
`;

export const SpaceTypeHeaderValue = styled.div`
  && {
    text-align: right;
    position: relative;
    span {
      text-align: right;
      font-size: 14px;
    }
  }
`;

export const SubcategoryContainer = styled.div`
  && {
    margin-top: 8px;
  }
`;

export const RowContainer = styled.div`
  &.show-border-top {
    border-top: 1px solid ${colors.offWhite};
  }
`;

export const AvgUSFBulkEditButton = styled(BulkEditButton)`
  margin-top: 0;
  transform: translateY(-4px);
`;

export const AvgSeatsBulkEditButton = styled(AvgUSFBulkEditButton)`
  width: 34px;
`;
